import { useState } from 'react';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import ActualizarTelefono from '../api/agregarTelefono';

function AgregarTelefono() {
    const [telefono, setTelefono] = useState("");
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const response = await ActualizarTelefono(telefono);

            if (response.ok) {
                window.location.reload(); // Recargamos para que el Nav detecte el cambio
            } else {
                setError("No se pudo guardar el teléfono. Inténtalo de nuevo.");
            }
        } catch (err) {
            setError("Error de conexión con el servidor.");
        }
    };

    return (
        <div className="p-4 border rounded shadow-sm">
            <h4>Completa tu perfil</h4>
            <p>Por favor, ingresa tu número de teléfono para continuar.</p>
            
            {error && <Alert variant="danger">{error}</Alert>}
            
            <Form onSubmit={handleSubmit}>
                <Row className="justify-content-center">
                    <Col md={6}> {/* Esto hace que ocupe la mitad (6 de 12 columnas) en pantallas medianas o superiores */}
                        <Form.Group className="mb-3">
                            <Form.Label>Teléfono</Form.Label>
                            <Form.Control 
                                type="tel" 
                                placeholder="Ej: 099123456" 
                                value={telefono}
                                onChange={(e) => setTelefono(e.target.value)}
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Button variant="primary" type="submit">
                    Guardar Teléfono
                </Button>
            </Form>
        </div>
    );
}

export default AgregarTelefono;